import React from 'react';
import LocalizedLink from 'components/LocalizedLink';
import WithlocalsLogoSmall from 'components/icons/WithlocalsLogoSmall';
import classnames from 'classnames';
import { Translator } from 'Translator';
import { isAndroidWeb } from 'utils/platform';
import { APPSTORE_LINK, PLAYSTORE_LINK, BUY_A_GIFT_VOUCHER_LINK } from '~/constants';
import GiftIcon from 'components/icons/GiftIcon';
import { useUser } from '~/authentication/store';

const CSS = require('./NavbarList.less');

const isAndroid = isAndroidWeb();

function HomeListItem({ onClick }) {
  const { isHost } = useUser();
  if (isHost) {
    return null;
  }
  return (
    <li className={classnames(CSS.MenuItem, CSS.MobileOnly)} onClick={onClick}>
      <LocalizedLink className={CSS.MenuItemLink} to={'/'}>
        {Translator.translate('Navbar.Menu.Home', {}, true, 'Home')}
      </LocalizedLink>
      <div className={CSS.IconContainer} />
    </li>
  );
}

function BuyAGiftVoucher({ onClick }) {
  return (
    <li className={classnames(CSS.MenuItem, CSS.MobileOnly)} onClick={onClick}>
      <a className={CSS.MenuItemLink} href={BUY_A_GIFT_VOUCHER_LINK} target="_blank" rel="noreferrer">
        Buy a gift voucher
      </a>
      <div className={CSS.IconContainer}>
        <GiftIcon />
      </div>
    </li>
  );
}

function DownloadAppListItem({ onClick }) {
  return (
    <li className={classnames(CSS.MenuItem, CSS.MobileOnly)} onClick={onClick}>
      <a href={isAndroid ? PLAYSTORE_LINK : APPSTORE_LINK} className={CSS.MenuItemButton}>
        {Translator.translate('Navbar.Buttons.downloadTheApp', {}, true, 'Download the app')}
      </a>
      <div className={CSS.IconContainer}>
        <div className={CSS.WithlocalsLogoContainer}>
          <WithlocalsLogoSmall className={CSS.WithlocalsLogo} width={24} height={24} color={'white'}/>
        </div>
      </div>
    </li>
  );
}

export {
  HomeListItem,
  DownloadAppListItem,
  BuyAGiftVoucher
};
